import { MonthsPipe } from '../../shared/pipes/months.pipe'

export function months ( monthsPipe : MonthsPipe ) {
  return ( month : number ) : string => monthsPipe.transform(month);
}
